import React, { useEffect, useState } from 'react'

const Kofi = () => {
    // Visible by default so the link is in the SSR HTML and doesn't depend
    // on hydration. Hiding happens post-mount, which never mismatches SSR.
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem('hideKofi')) {
            setHidden(true);
        }
    }, []);

    const hideForSession = (e) => {
        e.preventDefault();
        setHidden(true);
        sessionStorage.setItem('hideKofi', 'true');
    }

    if (hidden) return null;

    return (
        <>
            <a
                target="_blank"
                rel="noreferrer"
                href="https://ko-fi.com/javascriptbit"
            >Donate</a>
            <button style={{ marginLeft: '1em' }} onClick={hideForSession}>Hide for now</button>
        </>
    );
};

export default Kofi;
